import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { HttpResponseHandlerService } from '../services/http-response-handler.service';

@Injectable()
/**
 * Requires the currently logged in user to have selected a business unit
*/
export class UserBusinessUnitAuthGuard implements CanActivate {

    constructor(private _auth: AuthService,
        private router: Router,
        private httpResponseHandlerService: HttpResponseHandlerService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // check auth service for business unit access
        if (this._auth.hasApplicationAccess && !this._auth.hasBusinessUnitAccess) {
            this.httpResponseHandlerService.displayAccessDenied('You have not selected a business unit. Please select a business unit to continue.');
            this.router.navigate(['/', 'auth', 'bu']);
            return false;
        }
        return this._auth.hasBusinessUnitAccess;
    }

}
